import { ActivatedRoute } from '@angular/router';
import { Cell } from '../cell'
import { CellService } from '../cell.service';
import { Component, OnInit } from '@angular/core';
import { GlobalDataService } from '../../../../services/global-data.service';
import { Location } from '@angular/common';
import { Message } from 'primeng/primeng';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { StoreService } from '../../stores/store.service';

@Component({
  selector: 'app-cell-crud',
  templateUrl: './cell-crud.component.html',
  styleUrls: ['./cell-crud.component.css'],
  providers: [
              CellService,
              StoreService
             ]
})
export class CellCrudComponent implements OnInit {

  msgs: Message[] = [];
  cell: Cell;
  panel_header_caption: string = "Регистрация отсека";
  button_caption: string ="Сохранить";
  button_icon:string ="fa fa-save";
  selectedStore:string;
  loading: boolean = false;
  stores: any = [];
  id: any = null;  

  constructor(
              private activatedRoute: ActivatedRoute,
              private cellService: CellService,
              private global: GlobalDataService,
              private location: Location,
              private router: Router,
              private storeService: StoreService
             ) { 

          this.stores = this.global.user.stores.map(function(value){return {label: value.name, value: value.id}});

         activatedRoute.params.subscribe(params=>{this.id=params['id']});

              if(this.id){
                     this.loading=true;  
                     this.panel_header_caption = "Редактирования отсека";
                     this.button_caption="Редактировать";
                     this.button_icon="fa fa-edit";

                      this.cellService.getCellById(this.id).subscribe(response=>{
                          
                      this.storeService.getStore().subscribe(response=>{this.cell.stores=response['data'].map(function(value: any){
                            return {label:value.name, value: value.id};
                      }); 
                      this.loading=false;
                      })
                      

                      this.selectedStore = response['data'].store.id;
                      this.cell=response['data'];
                     });  
                  
             }else{
                     // this.cell.stores=this.stores;

                       // this.storeService.getStore().subscribe(response=>{this.cell.stores=response['data'].map(function(value: any){
                       //      return {label:value.name, value: value.id};
                       //    }); })
             }  
  }

  ngOnInit() {
        this.cell={
            id: "",
            name: "",
            stores: this.stores,
            available: true
        };
  }

  backClicked() {
        this.location.back();
  }


  crud(form: NgForm):void{
   
    if(!this.id){
             this.loading=true;  
             this.cellService.createCell(form.value)
             .subscribe((data) => {this.loading=false;this.router.navigate(['/dashboard/cell']);}
                  , (error)=>{
                           this.loading=false; 
                  });

         }else{
             this.loading=true;   
             this.cellService.updateCell(form.value,this.id)
             .subscribe((data) => {this.loading=false;this.router.navigate(['/dashboard/cell']);}
                  , (error)=>{
                              this.loading=false; 
                      });
         }


  }

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/cells/cell-crud/cell-crud.component.ts